<template>
    <div class="h-screen bg-very-light-gray">
        <div class="w-full">
            <div class="flex">
                <div class="w-full flex flex-col">
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>
